import { StoreData } from "../../types";
import { postRequestWrapper } from "../../utilities";

export type createStoreResponse = StoreData;

type createStoreBody = {
  name: string;
};

export function createStore(
  body: createStoreBody
): Promise<createStoreResponse> {
  return postRequestWrapper<createStoreBody, createStoreResponse>({
    url: `${ENV_SETTINGS.API_URL}/stores`,
    body,
  });
}
